import { useState, useEffect, useRef } from "react";
import DevQuestion from "./c_MathQuestion";
import axios from "axios";
import Select from "react-select";
import NavBar from "./c_sat_nav";
import { BASELINE } from "../../util";
import { eng_graph_1, Set_eng_graph_1 } from "../../gen_graph/Eng_Graph_1";
import { Set_eng_graph_2 } from "../../gen_graph/Eng_Graph_2";
import { TableData } from "../../gen_graph/Eng_Graph_3";
import { BarGraph2 } from "../../gen_graph/Eng_Graph_4";
import { BarGraph5 } from "../../gen_graph/Eng_Graph_5";
import { BarGraph6 } from "../../gen_graph/Eng_Graph_6";
import { Chart7 } from "../../gen_graph/Eng_Graph_7";

import ReactDOMServer from "react-dom/server";

const topics = {
  Algebra: [
    "Linear functions",
    "Systems of two linear equations in two variables",
    "Linear inequalities in one or two variables",
    "Linear equations in one variable",
    "Linear equations in two variables",
  ],
  "Advanced Math": [
    "Nonlinear functions",
    "Equivalent expressions",
    "Nonlinear equations in one variable and systems of equations in two variables",
  ],
  "Problem-solving and Data Analysis": [
    "Ratios, rates, proportional relationships, and units",
    "Inference from sample statistics and margin of error",
    "Probability and conditional probability",
    "Percentages",
    "One-variable data: Distributions and measures of center and spread",
    "Two-variable data: Models and scatterplots",
    "Evaluating statistical claims: Observational studies and experiments",
  ],
  "Geometry and Trigonometry": [
    "Lines, angles, and triangles",
    "Right triangles and trigonometry",
    "Area and volume",
    "Circles",
  ],
};


const graphlist = [
  "Eng_Graph_1",
  "Eng_Graph_2",
  "Eng_Graph_3",
  "Eng_Graph_4",
  "Eng_Graph_5",
  "Eng_Graph_6",
  "Eng_Graph_7"
];


const tags = ["eng", "math"];
const difficultys = ["E", "M", "H"];

const CDevQuiz = () => {
  const boxItemLeftRef = useRef();

  // 질문 관련 상태
  const [currentQuestion, setCurrentQuestion] = useState({
    stem: "",
    prompt: "",
    stimulus: "",
    a: "",
    b: "",
    c: "",
    d: "",
    correct_answer: "",
    rationale: "",
    primary_class_cd_descs: "",
    skill_descs: "",
    tags: "",
    difficultys: "",
  });

  // Autofill 모달 관련 상태
  const [showModal, setShowModal] = useState(false);
  const [autofillText, setAutofillText] = useState("");

  // Graph 모달 관련 상태
  const [showGraphModal, setShowGraphModal] = useState(false);
  const [showGraphForm, setShowGraphForm] = useState(false);
  const [graphForm, setGraphForm] = useState({ context: "", name: "" });
  const [graphList, setGraphList] = useState([]);
  const [generatedGraphs, setGeneratedGraphs] = useState([]);
  const [showExampleModal, setShowExampleModal] = useState(false);
  const [exampleText, setExampleText] = useState("");
  const [showPromptModal, setShowPromptModal] = useState(false);
  const [finalArray, setFinalArray] = useState([]);

  const printGraphSVG1 = (graphData) => {
    // JSX 엘리먼트를 생성할 때, prop 이름을 올바르게 전달해야 합니다.
    const svgMarkup = ReactDOMServer.renderToStaticMarkup(
      <Set_eng_graph_1 graphData={graphData} />
    );
    return svgMarkup;
  };

  const printGraphSVG2 = (graphData) => {
    // JSX 엘리먼트를 생성할 때, prop 이름을 올바르게 전달해야 합니다.
    const svgMarkup = ReactDOMServer.renderToStaticMarkup(
      <Set_eng_graph_2 graphData={graphData} />
    );

    return svgMarkup;
  };

  const printGraphSVG3 = (graphData) => {
    const svgMarkup = ReactDOMServer.renderToStaticMarkup(
      <TableData tableData={graphData} />
    );

    return svgMarkup;
  };

  const printGraphSVG4 = (graphData) => {
    const svgMarkup = ReactDOMServer.renderToStaticMarkup(
      <BarGraph5 data={graphData} />
    );
    //   console.log("SVG Markup:", svgMarkup);
    return svgMarkup;
  };

  const printGraphSVG5 = (graphData) => {
    const svgMarkup = ReactDOMServer.renderToStaticMarkup(
      <BarGraph2 data={graphData} />
    );
    return svgMarkup;
  };

  const printGraphSVG6 = (graphData) => {
    const svgMarkup = ReactDOMServer.renderToStaticMarkup(
      <BarGraph6 data={graphData} />
    );
    return svgMarkup;
  };

  const printGraphSVG7 = (graphData) => {
    const svgMarkup = ReactDOMServer.renderToStaticMarkup(
      <Chart7 data={graphData} />
    );
    return svgMarkup;
  };

  const handle_eng_graph_1 = async (count) => {
    try {
      const graphPromises = [];
      for (let i = 0; i < count; i++) {
        const data = {
          prompt: `Generate a random JSON object that strictly conforms to the following schema for the SAT English. Output only the JSON object with no extra text, commentary, or additional keys.
      schema: ${JSON.stringify(eng_graph_1)}

      Ensure that the output JSON exactly matches the schema above, with random but plausible values for numeric fields and meaningful strings for text fields.
Output only the JSON object and nothing else.`,
          // 필요한 경우 다른 데이터(예: qid 등)를 추가할 수 있음
        };

        graphPromises.push(
          axios.post(`${BASELINE}askai3`, data).then((res) => {
            if (res.data && res.data.message) {
              const ai_response = JSON.parse(res.data.message);
              // printGraphSVG1 함수는 SVG 문자열을 반환합니다.
              return printGraphSVG1(ai_response);
            } else {
              console.error("Unexpected response structure:", res.data);
              return null;
            }
          })
        );
      }
      const svgArray = await Promise.all(graphPromises);
      return svgArray;
    } catch (error) {
    }
  };

  const handle_eng_graph_2 = async (count) => {
    try {
      const graphPromises = [];
      for (let i = 0; i < count; i++) {
        const data = {
          prompt: `Generate a JSON object for the SAT English Bar Graph. Use the fixed design parameters exactly as specified in the schema below, and only randomize the "title" field and the numeric values in the "bars" array (for example, bar heights and y positions). Do not randomize any design elements such as width, height, viewBox, pattern, axis ticks, or other fixed layout values. Follow the schema exactly:
      
      {
        "width": 420,
        "height": 440,
        "viewBox": "0 0 420 440",
        "pattern": {
          "id": "bar4",
          "patternUnits": "userSpaceOnUse",
          "width": 10,
          "height": 100,
          "patternTransform": "rotate(50)",
          "x": 0,
          "y": 0,
          "rects": [
            { "x": 0, "y": 0, "width": 5, "height": 100, "fill": "#CDCDCD" },
            { "x": 5, "y": 0, "width": 5, "height": 100, "fill": "#444444" }
          ]
        },
        "yAxis": {
          "ticks": [
            { "position": 48, "label": "35" },
            { "position": 76.57142857142857, "label": "30" },
            { "position": 105.14285714285714, "label": "25" },
            { "position": 133.71428571428572, "label": "20" },
            { "position": 162.28571428571428, "label": "15" },
            { "position": 190.85714285714286, "label": "10" },
            { "position": 219.42857142857144, "label": "5" },
            { "position": 248, "label": "0" }
          ],
          "axisLabel": ["Rainfall", "(cm per week)"],
          "axisLine": { "x": 106.8125, "y1": 48, "y2": 248 }
        },
        "title": "Rainfall in Five Regions",   // <-- This field should be randomized.
        "bars": [
          { "region": "Region A", "x": 132.10227272727272, "y": 190, "width": 25.289772727272727, "height": 58 },
          { "region": "Region B", "x": 182.68181818181816, "y": 105, "width": 25.289772727272727, "height": 143 },
          { "region": "Region C", "x": 233.2613636363636, "y": 162, "width": 25.289772727272727, "height": 86 },
          { "region": "Region D", "x": 283.84090909090907, "y": 57, "width": 25.289772727272727, "height": 191 },
          { "region": "Region E", "x": 334.42045454545456, "y": 133, "width": 25.289772727272727, "height": 115 }
        ],
        "legend": {
          "box": { "x": 194.97659301757812, "y": 382.23974609375, "width": 101.85931396484375, "height": 26.84 },
          "items": [
            { "color": "#B3B3B3", "label": "region" }
          ]
        }
      }
      
      Output only the JSON object and nothing else.`,
        };

        graphPromises.push(
          axios.post(`${BASELINE}askai3`, data).then((res) => {
            if (res.data && res.data.message) {
              const ai_response = JSON.parse(res.data.message);
              // printGraphSVG1 함수는 SVG 문자열을 반환합니다.
              return printGraphSVG2(ai_response);
            } else {
              console.error("Unexpected response structure:", res.data);
              return null;
            }
          })
        );
      }
      const svgArray = await Promise.all(graphPromises);
      return svgArray;
    } catch (error) {
    }
  };

  const handle_eng_graph_3 = async (count) => {
    try {
      const graphPromises = [];
      for (let i = 0; i < count; i++) {
        const data = {
          prompt: `
        Generate a random JSON object representing table data for a SAT English problem, where the table caption, column headers, column key mapping, and row data are all randomly generated. The JSON must strictly follow the schema below and output only the JSON object with no extra text, commentary, or additional keys.

Schema:
{
  "caption": string,  // A random table title.
  "columns": [string, string, string, string],  // Four random column headers.
  "columnKeyMap": {
    // Each key is one of the column header strings from "columns", and its value is the corresponding key to be used in the row objects.
    // For example:
    // "Estimated footprint length (centimeters)" : "EstimatedFootprintLength"
  },
  "rows": [
    {
      // Use the keys specified in columnKeyMap.
      // For example, if columnKeyMap is:
      // {
      //   "Tracks": "Tracks",
      //   "Estimated footprint length (centimeters)": "EstimatedFootprintLength",
      //   "Average stride length (meters)": "AverageStrideLength",
      //   "Estimated mean speed (meters per second)": "EstimatedMeanSpeed"
      // }
      // then each row should have keys: Tracks, EstimatedFootprintLength, AverageStrideLength, EstimatedMeanSpeed.
      // The values should be random but plausible: a string for track names, numbers for lengths and strides, and a string range for speed.
    }
  ]
}

For example, a valid output might be:

{
  "caption": "Measurements from Two Sets of Prosauropod Tracks",
  "columns": [
    "Tracks",
    "Estimated footprint length (centimeters)",
    "Average stride length (meters)",
    "Estimated mean speed (meters per second)"
  ],
  "columnKeyMap": {
    "Tracks": "Tracks",
    "Estimated footprint length (centimeters)": "EstimatedFootprintLength",
    "Average stride length (meters)": "AverageStrideLength",
    "Estimated mean speed (meters per second)": "EstimatedMeanSpeed"
  },
  "rows": [
    {
      "Tracks": "Site Alpha",
      "EstimatedFootprintLength": 40.3,
      "AverageStrideLength": 6.84,
      "EstimatedMeanSpeed": "8.5–12.7"
    },
    {
      "Tracks": "Site Beta",
      "EstimatedFootprintLength": 42.1,
      "AverageStrideLength": 7.15,
      "EstimatedMeanSpeed": "9.2–13.1"
    }
  ]
}

Output only the JSON object and nothing else.
`};

        graphPromises.push(
          axios.post(`${BASELINE}askai3`, data).then((res) => {
            if (res.data && res.data.message) {
              const ai_response = JSON.parse(res.data.message);
              // printGraphSVG1 함수는 SVG 문자열을 반환합니다.
              return printGraphSVG3(ai_response);
            } else {
              console.error("Unexpected response structure:", res.data);
              return null;
            }
          })
        );
      }
      const svgArray = await Promise.all(graphPromises);
      return svgArray;
    } catch (error) {
    }
  };


  const handle_eng_graph_4 = async (count) => {
    try {
      const graphPromises = [];
      for (let i = 0; i < count; i++) {
        const data = {
          prompt: `
  Generate a random JSON object representing data. 
  Use the fixed design parameters exactly as specified below, and only randomize the title field and the numeric values in the "bars" array, label field, and bars name. 
  Do not randomize any design elements such as ticks, or colors.
  Everything needs to match to the title of the graph. 

  Schema:
  {
    "caption": string,                  // A random caption for the graph.
    "title": string,                    // Graph title (random).
    "xAxis": {
        "label": string,               // A random label for the graph.
        "categories": [string, string, string]  // Three robot names.
    },
    "yAxis": {
        "label": string,       // A random label for the graph.
        "ticks": [550,500,450,400,350,300,250,200,150,100,50,0]  // Fixed.
    },
    "bars": [
      {
         robot: string,              // Must match one of the xAxis.categories
         "value": number               // Random 0~550
      },
      {
         robot: string,
         "value": number
      },
      {
         robot: string,
         "value": number
      }
    ],
    "colors": ["#666666", "#CCCCCC", "#000000"]  // Fixed
  }
  
  Output only the JSON object and nothing else.
  `
        };

        graphPromises.push(
          axios.post(`${BASELINE}askai3`, data).then((res) => {
            if (res.data && res.data.message) {
              const ai_response = JSON.parse(res.data.message);
              // printGraphSVG1 함수는 SVG 문자열을 반환합니다.
              return printGraphSVG4(ai_response);
            } else {
              console.error("Unexpected response structure:", res.data);
              return null;
            }
          })
        );
      }
      const svgArray = await Promise.all(graphPromises);
      return svgArray;
    } catch (error) {
      console.error("Error in handle_eng_graph_4:", error);
    }
  };

  const handle_eng_graph_5 = async (count) => {
    try {
      const graphPromises = [];
      for (let i = 0; i < count; i++) {
        const data = {
          prompt: `
  Generate a random JSON object representing data for a bar graph where:
  - The x-axis represents **years**: "1980", "1990", "2000". This is example years, you can change them.
  - Each year contains **3 robot categories**.
  - The y-axis represents **randomized values between 0 and 550**.
  - Colors are fixed and must not be changed.
  - The title and labels should be randomly generated.
  
  ### Schema:
  {
    "caption": string,                  // A random caption for the graph.
    "title": string,                    // Graph title (randomized).
    "xAxis": {
        "label": "Year",               // Fixed label
        "categories": ["1980", "1990", "2000"] // Fixed years
    },
    "yAxis": {
        "label": string,       // A random label for the graph.
        "ticks": [550,500,450,400,350,300,250,200,150,100,50,0]  // Fixed.
    },
    "bars": [
      {
         "year": "1980",         // Must be "1980", "1990", or "2000"
         "robot": string,       // One of three random robot names.
         "value": number        // Random value between 0~550
      },
      {
         "year": "1980",
         "robot": string,
         "value": number
      },
      {
         "year": "1980",
         "robot": string,
         "value": number
      },
      {
         "year": "1990",
         "robot": string,
         "value": number
      },
      {
         "year": "1990",
         "robot": string,
         "value": number
      },
      {
         "year": "1990",
         "robot": string,
         "value": number
      },
      {
         "year": "2000",
         "robot": string,
         "value": number
      },
      {
         "year": "2000",
         "robot": string,
         "value": number
      },
      {
         "year": "2000",
         "robot": string,
         "value": number
      }
    ],
    "colors": ["#666666", "#CCCCCC", "#000000"]  // Fixed colors.
  }
  
Output only the JSON object and nothing else.
  `
        };

        graphPromises.push(
          axios.post(`${BASELINE}askai3`, data).then((res) => {
            if (res.data && res.data.message) {
              const ai_response = JSON.parse(res.data.message);
              // printGraphSVG1 함수는 SVG 문자열을 반환합니다.
              return printGraphSVG5(ai_response);
            } else {
              console.error("Unexpected response structure:", res.data);
              return null;
            }
          })
        );
      }
      const svgArray = await Promise.all(graphPromises);
      return svgArray;
    } catch (error) {
      console.error("Error in handle_eng_graph_5:", error);
    }
  };

  const handle_eng_graph_6 = async (count) => {
    try {
      const graphPromises = [];
      for (let i = 0; i < count; i++) {
        const data = {
          prompt: `
    Generate a random JSON object representing data. 
  Use the fixed design parameters exactly as specified below, and only randomize the title field and the numeric values in the "bars" array, label field, and bars name. 
  Do not randomize any design elements such as ticks, or colors.
  Everything needs to match to the title of the graph. 

Schema:
{
  "caption": string,                  // A random caption for the graph.
  "title": string,                    // Graph title (randomized).
  "xAxis": {
      "label": "Month",               // Fixed label.
      "categories": ["April", "May", "June", "July", "August"]  // change months in order.
  },
  "yAxis": {
      "label": "Hours of sunshine",   // Fixed label.
      "ticks": [350,300,250,200,150,100,50,0]  // Fixed tick values.
  },
  "lines": [
      {
         "name": string,              // Line name (e.g., "Anchorage").
         "values": [number, number, number, number, number, number] // One value for each month.
      },
      {
         "name": string,              // Line name (e.g., "Fairbanks").
         "values": [number, number, number, number, number, number]
      }
  ],
  "colors": ["#666666", "#CCCCCC"]     // Fixed colors for the lines.
}

Output only the JSON object and nothing else.
  `
        };

        graphPromises.push(
          axios.post(`${BASELINE}askai3`, data).then((res) => {
            if (res.data && res.data.message) {
              const ai_response = JSON.parse(res.data.message);
              // printGraphSVG1 함수는 SVG 문자열을 반환합니다.
              return printGraphSVG6(ai_response);
            } else {
              console.error("Unexpected response structure:", res.data);
              return null;
            }
          })
        );
      }
      const svgArray = await Promise.all(graphPromises);
      return svgArray;
    } catch (error) {
      console.error("Error in handle_eng_graph_5:", error);
    }
  };

  const handle_eng_graph_7 = async (count) => {
    try {
      const graphPromises = [];
      for (let i = 0; i < count; i++) {
        const data = {
          prompt: `
  Generate a random JSON object representing data for a table about the characteristics of five recently discovered gas exoplanets. Use the fixed design parameters exactly as specified below, and only randomize the "caption" field and the numeric values along with the exoplanet designations in the "rows" array. Do not randomize any design elements such as the column headers.
  
  Schema:
  {
    "caption": string,  
    "columns": [
       "Exoplanet designation",
       "Mass (Jupiters)",
       "Radius (Jupiters)",
       "Orbital period (days)",
       "Distance from the Sun (parsecs)"
    ],
    "rows": [
      {
         "designation": string,
         "mass": number,
         "radius": number,
         "orbitalPeriod": number,
         "distance": number
      },
      {
         "designation": string,
         "mass": number,
         "radius": number,
         "orbitalPeriod": number,
         "distance": number
      },
      {
         "designation": string,
         "mass": number,
         "radius": number,
         "orbitalPeriod": number,
         "distance": number
      },
      {
         "designation": string,
         "mass": number,
         "radius": number,
         "orbitalPeriod": number,
         "distance": number
      },
      {
         "designation": string,
         "mass": number,
         "radius": number,
         "orbitalPeriod": number,
         "distance": number
      }
    ]
  }
  
  Output only the JSON object and nothing else.
  `
        };

        graphPromises.push(
          axios.post(`${BASELINE}askai3`, data).then((res) => {
            if (res.data && res.data.message) {
              const ai_response = JSON.parse(res.data.message);
              // printGraphSVG1 함수는 SVG 문자열을 반환합니다.
              return printGraphSVG7(ai_response);
            } else {
              console.error("Unexpected response structure:", res.data);
              return null;
            }
          })
        );
      }
      const svgArray = await Promise.all(graphPromises);
      return svgArray;
    } catch (error) {
      console.error("Error in handle_eng_graph_7:", error);
    }
  };

  const handle_button = async (num) => {
    // 문제 개수를 입력받는 prompt
    const countInput = window.prompt("How many?", "1");
    // 입력값이 없거나 숫자가 아니면 조기 종료
    const count = parseInt(countInput, 10);
    if (isNaN(count) || count <= 0) {
      alert("Enter the number 1~9");
      return;
    }

    let svgArray = [];
    // 그래프 번호에 따라 해당 함수 실행
    if (num === 1) {
      svgArray = await handle_eng_graph_1(count);
    } else if (num === 2) {
      svgArray = await handle_eng_graph_2(count);
    } else if (num === 3) {
      svgArray = await handle_eng_graph_3(count);
    } else if (num === 4) {
      svgArray = await handle_eng_graph_4(count);
    } else if (num === 5) {
      svgArray = await handle_eng_graph_5(count);
    } else if (num === 6) {
      svgArray = await handle_eng_graph_6(count);
    } else if (num === 7) {
      svgArray = await handle_eng_graph_7(count);
    }

    // 생성된 SVG를 state에 저장
    setGeneratedGraphs(svgArray);

    // 그래프 생성 후 example 모달 오픈
    setShowExampleModal(true);
  };

  const getEnvironmentFields = () => {
    return {
      tags: currentQuestion.tags,
      difficultys: currentQuestion.difficultys,
      skill_descs: currentQuestion.skill_descs,
      primary_class_cd_descs: currentQuestion.primary_class_cd_descs,
    };
  };


  const handleExampleSubmit = () => {
    // environment 필드는 currentQuestion 중 특정값만 추출
    const environmentFields = getEnvironmentFields();

    // 혹시 generatedGraphs가 undefined일 수 있으므로 방어적으로 처리
    if (!Array.isArray(generatedGraphs)) {
      console.error("generatedGraphs is not an array:", generatedGraphs);
      return; // 함수 중단
    }

    // generatedGraphs 배열 각각에 대해 최종 객체를 만듦
    const finalArr = generatedGraphs.map((svgStr) => ({
      graph: svgStr,
      example_problems: exampleText,
      environment: environmentFields,
    }));

    // state로도 저장 (만약 finalArray라는 state가 있다고 가정)
    setFinalArray(finalArr);

    // 모달 닫기 & 초기화
    setShowExampleModal(false);
    setExampleText("");

    // Prompt 모달 열기 (만약 있다면)
    setShowPromptModal(true);
  };


  const handleCopyPrompt = (index) => {
    const item = finalArray[index];
    // 예: item.environment.skill_descs, item.environment.difficultys 등 참조
    const skillDesc = item.environment.skill_descs || "some skill";
    const difficulty = item.environment.difficultys || "M";

    // 원하는 형식으로 prompt 결합
    const textToCopy =
      JSON.stringify(item, null, 2) + // finalArray[i] 를 JSON으로
      "\n\nBased on the Graph above\n" +
      `Generate ${skillDesc} based multiple-choice questions in SAT format with a ${difficulty} difficulty level. Each question should follow this structure:\n\n` +
      `stem: The main question or task the student must answer.\n` +
      `stimulus: A passage or context (minimum 80 words)\n` +
      `a, b, c, d: Four answer choices.\n` +
      `correct_answer: The correct choice (randomized across a, b, c, d).\n` +
      `rationale: A detailed explanation (minimum 80 words) beginning with "Choice [BLANK] is the best answer. Because..."\n` +
      `Give the answer in JSON format.\n\n` +
      `Review the example_problems that I implemented above based on environment.\n`;

    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        alert(`Copied prompt for item #${index + 1} to clipboard!`);
      })
      .catch((err) => {
        console.error("Clipboard error:", err);
        alert("Failed to copy text.");
      });
  };

  // katex auto-render 스크립트 로드
  useEffect(() => {
    const script2 = document.createElement("script");
    script2.src =
      "https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/contrib/auto-render.min.js";
    script2.integrity =
      "sha384-+VBxd3r6XgURycqtZ117nYw44OOcIax56Z4dCRWbxyPt0Koah1uHoK0o4+/RRE05";
    script2.crossOrigin = "anonymous";
    script2.defer = true;

    script2.onload = () => {
      if (boxItemLeftRef.current && window.renderMathInElement) {
        window.renderMathInElement(boxItemLeftRef.current, {
          delimiters: [
            { left: "\\(", right: "\\)", display: false },
            { left: "\\[", right: "\\]", display: true },
            { left: "$$", right: "$$", display: false },
            { left: "$", right: "$", display: false },
          ],
          throwOnError: false,
        });
      }
    };

    document.body.appendChild(script2);
    return () => {
      document.body.removeChild(script2);
    };
  }, [
    currentQuestion.stimulus,
    currentQuestion.stem,
    currentQuestion.a,
    currentQuestion.b,
    currentQuestion.c,
    currentQuestion.d,
    currentQuestion.correct_answer,
    currentQuestion.rationale,
  ]);

  // 입력값 변경 핸들러
  const handlestem = (value) => {
    setCurrentQuestion((prev) => ({ ...prev, stem: value }));
  };

  const handlestimulus = (value) => {
    setCurrentQuestion((prev) => ({ ...prev, stimulus: value }));
  };

  const handlerationale = (value) => {
    setCurrentQuestion((prev) => ({ ...prev, rationale: value }));
  };

  // Soft Reset: Topic, Skills, Tags, Difficultys 제외한 필드 초기화
  const handleSoftReset = () => {
    setCurrentQuestion((prev) => ({
      ...prev,
      stem: "",
      prompt: "",
      stimulus: "",
      a: "",
      b: "",
      c: "",
      d: "",
      correct_answer: "",
      rationale: "",
    }));
  };

  // Hard Reset: 전체 필드 초기화
  const handleHardReset = () => {
    setCurrentQuestion({
      stem: "",
      prompt: "",
      stimulus: "",
      a: "",
      b: "",
      c: "",
      d: "",
      correct_answer: "",
      rationale: "",
      primary_class_cd_descs: "",
      skill_descs: "",
      tags: "",
      difficultys: "",
    });
  };

  // Update: 서버에 질문 데이터 전송
  const handleUpdate = () => {
    axios
      .post(BASELINE + "sat/add/mcq/question", currentQuestion)
      .then((response) => {
        alert("Question added successfully!");
      })
      .catch((error) => {
        console.error("Error adding question:", error);
        alert("Failed to add question. Check console for details.");
      });
  };

  // Autofill Submit
  const handleAutofillSubmit = () => {
    try {
      const data = JSON.parse(autofillText);
      if (Array.isArray(data)) {
        const enrichedData = data.map((question) => ({
          ...question,
          primary_class_cd_descs: currentQuestion.primary_class_cd_descs,
          skill_descs: currentQuestion.skill_descs,
          tags: currentQuestion.tags,
          difficultys: currentQuestion.difficultys,
        }));
        enrichedData.forEach((question, index) => {
          axios
            .post(BASELINE + "sat/add/mcq/question", question)
            .then((response) => { })
            .catch((error) => {
              console.error(`Error inserting question ${index + 1}:`, error);
            });
        });
        alert(`${enrichedData.length} questions have been submitted.`);
      } else {
        setCurrentQuestion((prev) => ({
          ...prev,
          ...data,
        }));
        alert("Question autofilled successfully!");
      }
      setShowModal(false);
      setAutofillText("");
    } catch (error) {
      alert("유효하지 않은 JSON 데이터입니다.");
    }
  };

  // Graph 모달 열기/닫기 핸들러
  const handleGraphModalOpen = () => {
    setShowGraphModal(true);
  };

  const handleGraphModalClose = () => {
    setShowGraphModal(false);
    setShowGraphForm(false);
  };

  // 그래프 추가 폼 제출 핸들러
  const handleGraphFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(BASELINE + "post/devtable", graphForm);
      if (response.data.success) {
        // API에서 반환한 id를 활용하여 그래프 리스트에 추가
        setGraphList((prev) => [
          ...prev,
          { ...graphForm, id: response.data.id },
        ]);
        setGraphForm({ context: "", name: "" });
        setShowGraphForm(false);
        alert("Graph added successfully!");
      } else {
        alert("Failed to add graph: " + response.data.message);
      }
    } catch (error) {
      console.error("Error adding graph:", error);
      alert("Error adding graph. Check console for details.");
    }
  };

  return (
    <div className="fbg-white">

      <NavBar
        handleSoftReset={handleSoftReset}
        handleReset={handleHardReset}
        handleUpdate={handleUpdate}
        handleautofill={() => setShowModal(true)}
        handleGraphModal={handleGraphModalOpen}
      // 나머지 select 관련 props가 있다면 추가 전달
      />

      {showPromptModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
          <div className="bg-white p-4 rounded shadow-lg w-[90%] max-w-2xl relative">
            {/* 모달 헤더 */}
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">Copy the Prompt</h2>
              <button
                onClick={() => setShowPromptModal(false)}
                className="text-gray-600 hover:text-black"
              >
                X
              </button>
            </div>

            {/* 그래프 갯수만큼 버튼 표시 */}
            {finalArray.length === 0 ? (
              <p>No final data found.</p>
            ) : (
              <div className="grid grid-cols-1 gap-2">
                {finalArray.map((item, i) => (
                  <button
                    key={`prompt-btn-${i}`}
                    onClick={() => handleCopyPrompt(i)}
                    className="bg-green-600 text-white px-4 py-2 rounded"
                  >
                    Copy Prompt for Graph #{i + 1}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {showExampleModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
          <div className="bg-white p-4 rounded shadow-lg w-[80%] max-w-xl relative">
            {/* 모달 헤더 (title, close) */}
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">example</h2>
              <button
                onClick={() => setShowExampleModal(false)}
                className="text-gray-600 hover:text-black"
              >
                X
              </button>
            </div>
            {/* example textarea */}
            <textarea
              className="w-full h-48 border border-gray-300 p-2"
              placeholder="Write your example text here..."
              value={exampleText}
              onChange={(e) => setExampleText(e.target.value)}
            />
            {/* Submit 버튼 */}
            <div className="flex justify-end mt-3">
              <button
                onClick={handleExampleSubmit}
                className="bg-blue-600 text-white px-4 py-2 rounded"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Autofill Modal */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-4 rounded shadow-lg w-[80%] max-w-lg">
            <textarea
              className="w-full h-64 border border-gray-300 p-2"
              placeholder="Insert the JSON data"
              value={autofillText}
              onChange={(e) => setAutofillText(e.target.value)}
            />
            <div className="flex justify-end mt-2 gap-2">
              <button
                onClick={() => {
                  setShowModal(false);
                  setAutofillText("");
                }}
                className="bg-gray-500 text-white p-2 rounded"
              >
                Close
              </button>
              <button
                onClick={handleAutofillSubmit}
                className="bg-green-500 text-white p-2 rounded"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Graph Modal */}
      {showGraphModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-4 rounded shadow-lg w-[80%] max-w-lg">
            {/* 모달 상단: Close 버튼 */}
            <div className="flex justify-between mb-4">
              <button
                onClick={handleGraphModalClose}
                className="bg-gray-500 text-white p-2 rounded"
              >
                Close
              </button>
            </div>

            {/* Graph 카드 리스트 */}
            <div className="grid grid-cols-3 gap-4">
              {graphlist.length === 0 ? (
                <p>No graphs available.</p>
              ) : (
                graphlist.map((graph, idx) => (
                  <div
                    key={graph}
                    className="border border-gray-300 p-4 rounded shadow"
                    onClick={() => handle_button(idx + 1)}
                  >
                    <img
                      src={`/dashboard/${graph}.png`}
                      alt={graph}
                      className="w-full h-auto mb-2"
                    />
                    <h3 className="font-bold text-center">{graph}</h3>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      )}

      {/* Topic, Skills, Tags, Difficultys 선택 영역 */}
      <div className="flex gap-2 p-2">
        <div className="w-[25%]">
          <p>Topic:</p>
          <Select
            value={
              currentQuestion.primary_class_cd_descs
                ? currentQuestion.primary_class_cd_descs
                  .split(",")
                  .map((topic) => ({ value: topic, label: topic }))
                : []
            }
            isMulti
            onChange={(selectedOptions) => {
              const selectedValues = selectedOptions.map(
                (option) => option.value
              );
              setCurrentQuestion((prev) => ({
                ...prev,
                primary_class_cd_descs: selectedValues.join(","),
              }));
            }}
            options={Object.keys(topics).map((topic) => ({
              value: topic,
              label: topic,
            }))}
            className="basic-multi-select lg:min-w-[300px] lg:max-w-[300px]"
            classNamePrefix="select"
          />
        </div>

        <div className="w-[25%]">
          <p>Skills:</p>
          <Select
            value={
              currentQuestion.skill_descs
                ? currentQuestion.skill_descs
                  .split(",")
                  .map((skill) => ({ value: skill, label: skill }))
                : []
            }
            isMulti
            onChange={(selectedOptions) => {
              const selectedValues = selectedOptions.map((option) => option.value);
              setCurrentQuestion((prev) => ({
                ...prev,
                skill_descs: selectedValues.join(","),
              }));
            }}
            options={Object.entries(topics)
              .flatMap(([topic, skills]) =>
                topic === "Standard English Conventions"
                  ? [{ value: "Form, Structure, and Sense", label: "Form, Structure, and Sense" }]
                  : skills.map((skill) => ({ value: skill, label: skill }))
              )}
            className="basic-multi-select lg:min-w-[300px] lg:max-w-[300px]"
            classNamePrefix="select"
          />
        </div>

        <div className="w-[25%]">
          <p>Tags:</p>
          <Select
            value={
              currentQuestion.tags
                ? currentQuestion.tags
                  .split(",")
                  .map((tag) => ({ value: tag, label: tag }))
                : []
            }
            isMulti
            onChange={(selectedOptions) => {
              const selectedValues = selectedOptions.map(
                (option) => option.value
              );
              setCurrentQuestion((prev) => ({
                ...prev,
                tags: selectedValues.join(","),
              }));
            }}
            options={tags.map((tag) => ({ value: tag, label: tag }))}
            className="basic-multi-select lg:min-w-[300px] lg:max-w-[300px]"
            classNamePrefix="select"
          />
        </div>

        <div className="w-[25%]">
          <p>Difficultys:</p>
          <Select
            value={
              currentQuestion.difficultys
                ? currentQuestion.difficultys
                  .split(",")
                  .map((difficulty) => ({
                    value: difficulty,
                    label: difficulty,
                  }))
                : []
            }
            isMulti
            onChange={(selectedOptions) => {
              const selectedValues = selectedOptions.map(
                (option) => option.value
              );
              setCurrentQuestion((prev) => ({
                ...prev,
                difficultys: selectedValues.join(","),
              }));
            }}
            options={difficultys.map((difficulty) => ({
              value: difficulty,
              label: difficulty,
            }))}
            className="basic-multi-select lg:min-w-[300px] lg:max-w-[300px]"
            classNamePrefix="select"
          />
        </div>
      </div>

      {/* DevQuestion 컴포넌트에 필요한 데이터 전달 */}
      <DevQuestion
        currentQuestion={currentQuestion}
        stimulus={currentQuestion.stimulus}
        stem={currentQuestion.stem}
        a={currentQuestion.a}
        b={currentQuestion.b}
        c={currentQuestion.c}
        d={currentQuestion.d}
        correct_answer={currentQuestion.correct_answer}
        rationale={currentQuestion.rationale}
      />

      {/* 왼쪽: stem, prompt, stimulus 편집 영역 */}
      <div className="flex z-[10] mt-[10px]">
        <div className="flex flex-col justify-start w-[50%]">
          <div>
            <p>Edit question stem here</p>
            <textarea
              value={currentQuestion.stem}
              onChange={(e) => handlestem(e.target.value)}
              className={`w-full ${currentQuestion.stem ? "h-[500px]" : "h-[20px]"
                } p-2 overflow-y-auto overflow-x-hidden my-list-style border border-gray-300`}
              placeholder="Edit question stem here"
            />

            <p>Edit question stimulus here</p>
            <textarea
              value={currentQuestion.stimulus}
              onChange={(e) => handlestimulus(e.target.value)}
              className={`w-full ${currentQuestion.stimulus ? "h-[500px]" : "h-[20px]"
                } p-2 overflow-y-auto overflow-x-hidden my-list-style border border-gray-300 mt-2`}
              placeholder="Edit question stimulus here"
            />
          </div>
        </div>

        {/* 오른쪽: 옵션 및 정답 편집 영역 */}
        <div className="flex flex-col gap-2 my-4 w-[50%]">
          <p className="mt-2">Answer A:</p>
          <textarea
            className="border border-gray-300 p-2 w-full"
            value={currentQuestion.a}
            onChange={(e) =>
              setCurrentQuestion((prev) => ({ ...prev, a: e.target.value }))
            }
            placeholder="Edit option A"
          />

          <p className="mt-2">Answer B:</p>
          <textarea
            className="border border-gray-300 p-2 w-full"
            value={currentQuestion.b}
            onChange={(e) =>
              setCurrentQuestion((prev) => ({ ...prev, b: e.target.value }))
            }
            placeholder="Edit option B"
          />

          <p className="mt-2">Answer C:</p>
          <textarea
            className="border border-gray-300 p-2 w-full"
            value={currentQuestion.c}
            onChange={(e) =>
              setCurrentQuestion((prev) => ({ ...prev, c: e.target.value }))
            }
            placeholder="Edit option C"
          />

          <p className="mt-2">Answer D:</p>
          <textarea
            className="border border-gray-300 p-2 w-full"
            value={currentQuestion.d}
            onChange={(e) =>
              setCurrentQuestion((prev) => ({ ...prev, d: e.target.value }))
            }
            placeholder="Edit option D"
          />

          <p className="mt-2">Correct Answer:</p>
          <textarea
            className="border border-gray-300 p-2 w-full"
            value={currentQuestion.correct_answer}
            onChange={(e) =>
              setCurrentQuestion((prev) => ({
                ...prev,
                correct_answer: e.target.value,
              }))
            }
            placeholder="Edit correct answer"
          />
        </div>
      </div>

      {/* 하단: 질문 해설 (rationale) 편집 영역 */}
      <p className="font-bold">Question Rationale</p>
      <div
        className="ml-[20px] flex z-[10] mt-[10px] gap-2 p-2"
        id="box-item-left"
        ref={boxItemLeftRef}
      >
        <div className="max-w-[50%]">
          <div
            className="min-h-[40%] overflow-y-auto overflow-x-hidden my-list-style"
            dangerouslySetInnerHTML={{ __html: currentQuestion.rationale }}
          />
        </div>

        <div className="w-[50%]">
          <textarea
            value={currentQuestion.rationale}
            onChange={(e) => handlerationale(e.target.value)}
            className="h-[100%] w-full p-2 overflow-y-auto overflow-x-hidden my-list-style border border-gray-300"
            placeholder="Edit question rationale here"
          />
        </div>
      </div>
    </div>
  );
};

export default CDevQuiz;
